import { PAYMENT_CARD_LABEL_KEYS } from '../../payment/constants';
import type { CreditCardType } from '../../payment/types';

export function getCreditCardLabelByCardType(type: CreditCardType, constants: Record<string, string>): string {
  return constants[PAYMENT_CARD_LABEL_KEYS[type]] ?? type;
}
